/**
 * Procedure Categories and Procedures for M.Ch. in Plastic & Reconstructive Surgery students
 * Extracted with strict evidence from official NMC PDF (Page 7-10: "Psychomotor domain - Perform Independently")
 */
export const PLASTIC_SURGERY_PROCEDURES = {
  "Wound Management, Skin Grafting & Flap Surgery Procedures": [
    "Surgical Wound Debridement & Negative Pressure Wound Therapy (NPWT / VAC)",
    "Split-Thickness (STSG) & Full-Thickness (FTSG) Skin Graft Harvesting & Meshing",
    "Cutaneous Perforator Doppler Mapping & Local / Pedicled Skin Flap Elevation",
    "Muscle, Musculocutaneous, Osseous & Free Microvascular Flap Surgeries",
    "Flap Revision, Debulking & Z-Plasty Scar Revision",
    "Harvest of Bone, Cartilage & Tendon Autografts",
    "Tumescent Local Anaesthesia, Nerve Blocks & Regional Anaesthesia",
  ],
  "Microvascular, Peripheral Nerve, Hand & Maxillofacial Procedures": [
    "Microvascular Vessel Anastomosis & Free Tissue Transfer",
    "Peripheral Nerve Repair (Neurorrhaphy), Nerve Grafting & Brachial Plexus Decompression",
    "Flexor & Extensor Tendon Repair & Tendon Transfer Procedures",
    "Local & Cross-Finger Flaps for Fingertip & Digit Reconstruction",
    "Intermaxillary Fixation (IMF), Arch Bar Application & Facial Fracture Plating (Mandible/Maxilla/Zygoma)",
    "Unilateral & Bilateral Cleft Lip & Cleft Palate Repair",
    "Hand & Upper Extremity Amputations & Infection Drainage (Paronychia, Tenosynovitis)",
  ],
  "Burn Resuscitation, Breast & Aesthetic Reconstructive Procedures": [
    "Acute Burn Management, Escharotomy, Escharectomy & Fasciotomy",
    "Post-Burn Contracture Release & Flap Resurfacing (Neck, Axilla, Joints, Hand)",
    "Pressure Sore Debridement & Flap Coverage (Gluteal, TFL, Vastus Lateralis, Hamstring)",
    "Gynecomastia Subcutaneous Excision & Reduction / Augmentation Mammoplasty",
    "Aesthetic Facial Surgery (Blepharoplasty, Rhinoplasty, Facelift, Scar Revision & Ear Lobe Repair)",
    "Hair Restoration (FUT / FUE) & Botulinum Toxin / Filler Administration",
  ],
};

export const PLASTIC_SURGERY_CATEGORIES = Object.keys(PLASTIC_SURGERY_PROCEDURES);

export const isMChInPlasticSurgeryDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return (
    d.includes("plastic") ||
    d.includes("reconstructive surgery") ||
    d.includes("burns")
  );
};
